import React, { useState } from 'react';
import CodeExampleComponent from './CodeExampleComponent';
import CodeBlock from './CodeBlock';

const EndpointComponent = ({ endpoint }) => {
    const { name, method, path, description, parameters, responses } = endpoint;
    const [selectedLanguage, setSelectedLanguage] = useState('curl');

    return (
        <div className="space-y-6">
            {/* <div className="flex items-center">
        <div className={`px-3 py-1.5 rounded text-xs font-medium uppercase text-white ${
          method.toLowerCase() === 'get' ? 'bg-blue-400' :
          method.toLowerCase() === 'post' ? 'bg-green-500' :
          method.toLowerCase() === 'put' ? 'bg-yellow-500' :
          method.toLowerCase() === 'delete' ? 'bg-red-500' : 'bg-gray-500'
        }`}>
          {method}
        </div>
        <h3 className="font-mono text-base ml-4 text-gray-700">{path}</h3>
      </div> */}

            <div>
                {/* <h3 className="text-lg font-semibold mb-2 text-gray-800">{name}</h3> */}
                <p className="mb-6">{description}</p>
            </div>

            {parameters.length > 0 && (
                <div className="mb-8">
                    <h4 className="font-medium mb-1 text-[--gray-12]">参数</h4>
                    <div className="divide-y border-[--gray-5]">
                        {parameters.map((param, index) => (
                            <div key={index} className="py-4">
                                <div className="flex flex-wrap items-center gap-2 mb-2">
                                    <span className={`font-mono text-[14px] ${param.inPath ? 'text-[--pink-9]' : 'text-[--gray-11]'}`}>
                                        {param.name}
                                        {param.inPath && ' (路径参数)'}
                                    </span>
                                    <div className="px-2 py-0.5 rounded text-xs bg-[--gray-3] text-[--gray-11]">
                                        {param.type}
                                    </div>
                                    {param.required && (
                                        <div className="px-2 py-0.5 rounded text-xs bg-[--c-3] text-[--cyan-10]">
                                            必填
                                        </div>
                                    )}
                                </div>
                                <p className="text-sm text-[--gray-11]">{param.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className="mb-8">
                <h4 className="font-medium mb-3 text-[--gray-12]">响应</h4>
                <div>
                    {/* 状态码统一展示区 - 使用 bullet points */}
                    <ul className="pl-5 mb-6 space-y-1.5 list-disc">
                        {responses.map((response, index) => (
                            <li 
                                key={index} 
                                className="text-sm"
                            >
                                <span className={`font-mono font-medium ${
                                    response.status >= 200 && response.status < 300 ? 'text-[--green-9]' :
                                    response.status >= 400 ? 'text-[--red-9]' : 
                                    'text-[--blue-9]'
                                }`}>
                                    {response.status}
                                </span>
                                <span className="ml-2 text-[--gray-11]">{response.description}</span>
                            </li>
                        ))}
                    </ul>

                    {/* 只展示有返回字段的状态码 */}
                    {responses.filter(r => r.fields && r.fields.length > 0).map((response, index) => (
                        <div key={index} className="mt-6 first:mt-0">
                            <div className="mb-2 text-[14px]">
                                <span className={`font-mono font-medium ${
                                    response.status >= 200 && response.status < 300 ? 'text-[--green-9]' :
                                    response.status >= 400 ? 'text-[--red-9]' : 
                                    'text-[--blue-9]'
                                }`}>
                                    {response.status}
                                </span>
                                <span className="ml-2 text-[--gray-11]">返回字段</span>
                            </div>
                            
                            <div className="rounded-md overflow-hidden bg-[--gray-2] border border-[--gray-4]">
                                {response.fields.map((field, i) => (
                                    <div key={i} className={`flex flex-col gap-1 px-4 py-3 ${i !== 0 ? 'border-t border-[--gray-4]' : ''}`}>
                                        <div className="flex flex-wrap items-center gap-2 mb-1">
                                            <span className="font-mono text-[14px] text-[--gray-12]">
                                                {field.name || field}
                                            </span>
                                            {field.type && (
                                                <div className="px-1.5 rounded text-xs bg-[--gray-3] text-[--gray-10]">
                                                    {field.type}
                                                </div>
                                            )}
                                            {field.required && (
                                                <div className="px-1.5 rounded text-xs text-[--blue-9]">
                                                    必填
                                                </div>
                                            )}
                                        </div>
                                        {field.description && (
                                            <p className="text-sm text-[--gray-11]">{field.description}</p>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <CodeExampleComponent 
                endpoint={endpoint} 
                selectedLanguage={selectedLanguage} 
                setSelectedLanguage={setSelectedLanguage} 
            />
        </div>
    );
};

export default EndpointComponent; 